import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	configureColumnsErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnConfigMutationErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnResizeMutationErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnResizeMutationErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reorderErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reorderErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reorderErrorTitleIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	configureColumnsErrorTitle: {
		id: 'issue-view-child-issues-panel.common.flags.configure-columns-error-title',
		defaultMessage: "We couldn't configure the columns",
		description:
			"Displayed as error flag's title when an unexpected error happens while user is trying to configure columns in a table.",
	},
	columnConfigMutationErrorDescription: {
		id: 'issue-view-child-issues-panel.common.flags.column-config-mutation-error-description',
		defaultMessage: 'Refresh and try again.',
		description:
			"Displayed as error flag's description when an unexpected error happens while user is trying to configure or edit columns in a table.",
	},
	columnResizeMutationErrorTitle: {
		id: 'issue-view-child-issues-panel.common.flags.column-resize-mutation-error-title',
		defaultMessage: "We couldn't resize the column",
		description:
			"Displayed as error flag's title when an unexpected error happens while user is trying to resize a column in the child issue table.",
	},
	columnResizeMutationErrorDescription: {
		id: 'issue-view-child-issues-panel.common.flags.column-resize-mutation-error-description',
		defaultMessage: 'Refresh and try again.',
		description:
			"Displayed as error flag's description when an unexpected error happens while user is trying to resize a column in the child issue table.",
	},
	reorderErrorTitle: {
		id: 'issue-view-child-issues-panel.common.flags.reorder-error-title',
		defaultMessage: "We couldn't reorder those issues",
		description: 'Heading text for error flag that appears when reordering fails',
	},
	reorderErrorDescription: {
		id: 'issue-view-child-issues-panel.common.flags.reorder-error-description',
		defaultMessage: 'Wait a few moments, then give it another try.',
		description: 'Body text for error flag that appears when reordering fails',
	},
	reorderErrorTitleIssueTermRefresh: {
		id: 'issue-view-child-issues-panel.common.flags.reorder-error-title-issue-term-refresh',
		defaultMessage: "We couldn't reorder those work items",
		description: 'Heading text for error flag that appears when reordering fails',
	},
});
export default messages;
